import React from 'react';
import { Link } from 'react-router-dom';
import { CircleDot, Instagram, Twitter, MessageCircle, Cloud } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { path: '/', label: 'Home' },
    { path: '/beliefs', label: 'Beliefs' },
    { path: '/practice', label: 'Practice' },
    { path: '/prayer', label: 'Prayer' },
    { path: '/codex', label: 'Codex' },
    { path: '/about', label: 'About' },
    { path: '/support', label: 'Support' },
    { path: '/contact', label: 'Contact' }
  ];

  const socialLinks = [
    { name: 'Instagram', icon: <Instagram size={20} />, url: '#' },
    { name: 'X (Twitter)', icon: <Twitter size={20} />, url: '#' },
    { name: 'Threads', icon: <MessageCircle size={20} />, url: '#' },
    { name: 'Bluesky', icon: <Cloud size={20} />, url: '#' }
  ];

  return (
    <footer className="footer cosmic-bg">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <CircleDot size={32} className="footer-logo-icon" />
              <span className="footer-logo-text">Cosmergence</span>
            </div>
            <p className="footer-tagline">
              Nothing is lost. Live in tune. Return with gratitude.
            </p>
          </div>

          <div className="footer-links">
            <h4 className="footer-links-title">Navigate</h4>
            <ul className="footer-links-list">
              {footerLinks.map(link => (
                <li key={link.path}>
                  <Link to={link.path} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-microcopy">
            <p className="microcopy" style={{fontSize: '12px'}}>
              Cosmergence is ad-free. <Link to="/support" style={{color: 'var(--accent-gold)', textDecoration: 'none'}}>Support our mission →</Link>
            </p>
            
            <div className="footer-social">
              <p className="footer-social-title">Connect</p>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    className="social-link"
                    aria-label={social.name}
                    title={`${social.name} (Coming Soon)`}
                    onClick={(e) => {
                      if (social.url === '#') {
                        e.preventDefault();
                      }
                    }}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            © {currentYear} Cosmergence. All patterns flow, all resonance remains.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;